import { render } from "./container-groups.vue?vue&type=template&id=c97e34c6"
import script from "./container-groups.vue?vue&type=script&lang=js"
export * from "./container-groups.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__